module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1215.159fd49f.png";